"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import { GlobalStyles } from "./GlobalStyles";
import { Navbar } from "./Navbar";
import { HomeHero } from "./HomeHero";
import { HeroSubCardComponentContainer } from "./HeroSubCardComponentContainer";
import { Communities } from "./Communities";
import { FeaturedSlideImage } from "./FeaturedSlideImage";
import { ButtonPrimaryBlack } from "./ButtonPrimaryBlack";
import { ButtonPrimaryWhite } from "./ButtonPrimaryWhite";
import { MattersCardsGrid } from "./MattersCardsGrid";
import { Gallery } from "./Gallery";
import { ContactFormHomePage } from "./ContactFormHomePage";
import { Footer } from "./Footer";

const _interactionsData = JSON.parse(
  '{"events":{"e-31":{"id":"e-31","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-32"}},"mediaQueries":["main"],"target":{"selector":".navbar_interaction-trigger","originalId":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"CLASS"},"targets":[{"id":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1702402485163},"e-32":{"id":"e-32","name":"","animationType":"custom","eventTypeId":"SCROLL_OUT_OF_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-16","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-31"}},"mediaQueries":["main"],"target":{"selector":".navbar_interaction-trigger","originalId":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"CLASS"},"targets":[{"id":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1702402485163},"e-135":{"id":"e-135","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-136"}},"mediaQueries":["main","medium"],"target":{"id":"a6f77999-6495-9b69-3c8e-0691392f732e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"a6f77999-6495-9b69-3c8e-0691392f732e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1709592418887},"e-136":{"id":"e-136","name":"","animationType":"custom","eventTypeId":"SCROLL_OUT_OF_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-16","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-135"}},"mediaQueries":["main","medium"],"target":{"id":"a6f77999-6495-9b69-3c8e-0691392f732e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"a6f77999-6495-9b69-3c8e-0691392f732e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1709592418888}},"actionLists":{"a-15":{"id":"a-15","title":"Navbar [transparent]","actionItemGroups":[{"actionItems":[{"id":"a-15-n","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":0}}]},{"actionItems":[{"id":"a-15-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":0}}]}],"useFirstGroupAsInitialState":true,"createdOn":1702402503174},"a-16":{"id":"a-16","title":"Navbar [solid]","actionItemGroups":[{"actionItems":[{"id":"a-16-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":1}}]}],"useFirstGroupAsInitialState":false,"createdOn":1702402503174}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function PageComponentHome({
  as: _Component = _Builtin.Block,
  formSlot,
  searchInputSlot,
  toggleSearchButtonProps,
}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <_Component className="page-component" tag="div">
      <GlobalStyles />
      <_Builtin.Block className="page-wrapper" tag="div">
        <_Builtin.Block
          className="navbar_interaction-trigger"
          data-w-id="a6f77999-6495-9b69-3c8e-0691392f732e"
          tag="div"
        />
        <Navbar />
        <_Builtin.Block className="main-wrapper" tag="main">
          <HomeHero
            searchInputSlot={searchInputSlot}
            toggleSearchButtonProps={toggleSearchButtonProps}
          />
          <HeroSubCardComponentContainer />
          <Communities />
          <_Builtin.Block className="featured" tag="section">
            <_Builtin.Block className="featured_wrapper" tag="div">
              <_Builtin.Block className="featured_gallery" tag="div">
                <_Builtin.SliderWrapper
                  className="slider"
                  id="featuredSlider"
                  navSpacing={3}
                  navShadow={false}
                  autoplay={false}
                  delay={4000}
                  iconArrows={true}
                  animation="slide"
                  navNumbers={false}
                  easing="ease"
                  navRound={false}
                  hideArrows={false}
                  disableSwipe={false}
                  duration={500}
                  infinite={true}
                  autoMax={0}
                  navInvert={false}
                >
                  <_Builtin.SliderMask className="mask">
                    <_Builtin.SliderSlide className="featured_slide" tag="div">
                      <FeaturedSlideImage featuredSlideImageImage="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dd14e43d93002074633ef2_the-monterey-pool-1080-1080%20(4).jpg" />
                    </_Builtin.SliderSlide>
                    <_Builtin.SliderSlide className="featured_slide" tag="div">
                      <FeaturedSlideImage featuredSlideImageImage="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dd14e4ced4e9101a35865b_the-monterey-clubhouse-1080-1080.jpg" />
                    </_Builtin.SliderSlide>
                    <_Builtin.SliderSlide className="featured_slide" tag="div">
                      <FeaturedSlideImage featuredSlideImageImage="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dd14e43d93002074633f1c_the-monterey-null-1080-1080.jpg" />
                    </_Builtin.SliderSlide>
                    <_Builtin.SliderSlide className="featured_slide" tag="div">
                      <FeaturedSlideImage featuredSlideImageImage="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dd14e34f4da1d2e4daeb14_the-monterey-fitness-center-1080-1080.jpg" />
                    </_Builtin.SliderSlide>
                    <_Builtin.SliderSlide className="featured_slide" tag="div">
                      <FeaturedSlideImage featuredSlideImageImage="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dd14e43d93002074633f1c_the-monterey-null-1080-1080.jpg" />
                    </_Builtin.SliderSlide>
                    <_Builtin.SliderSlide className="featured_slide" tag="div">
                      <FeaturedSlideImage featuredSlideImageImage="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dd14e4c6308b01ce93f6af_the-monterey-pool-1080-1080%20(2).jpg" />
                    </_Builtin.SliderSlide>
                  </_Builtin.SliderMask>
                  <_Builtin.SliderArrow className="left-arrow" dir="left">
                    <_Builtin.Block className="div-block-89" tag="div">
                      <_Builtin.HtmlEmbed
                        className="icon-embed-xsmall"
                        value="%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20aria-hidden%3D%22true%22%20role%3D%22img%22%20class%3D%22iconify%20iconify--heroicons%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20preserveaspectratio%3D%22xMidYMid%20meet%22%20viewbox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22none%22%20stroke%3D%22currentColor%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20d%3D%22M6.75%2015.75L3%2012m0%200l3.75-3.75M3%2012h18%22%2F%3E%3C%2Fsvg%3E"
                      />
                    </_Builtin.Block>
                  </_Builtin.SliderArrow>
                  <_Builtin.SliderArrow className="right-arrow" dir="right">
                    <_Builtin.Block className="div-block-89" tag="div">
                      <_Builtin.HtmlEmbed
                        className="icon-embed-xsmall"
                        value="%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20aria-hidden%3D%22true%22%20role%3D%22img%22%20class%3D%22iconify%20iconify--heroicons%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20preserveaspectratio%3D%22xMidYMid%20meet%22%20viewbox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22none%22%20stroke%3D%22currentColor%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20d%3D%22M17.25%208.25L21%2012m0%200l-3.75%203.75M21%2012H3%22%2F%3E%3C%2Fsvg%3E"
                      />
                    </_Builtin.Block>
                  </_Builtin.SliderArrow>
                  <_Builtin.SliderNav className="hide" />
                </_Builtin.SliderWrapper>
              </_Builtin.Block>
              <_Builtin.Block className="featured_description" tag="div">
                <_Builtin.Block className="max-width-medium" tag="div">
                  <_Builtin.Block
                    className="margin-bottom margin-small"
                    tag="div"
                  >
                    <_Builtin.Block className="eyebrow" tag="div">
                      {"Featured Property"}
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className="margin-bottom margin-xsmall"
                    tag="div"
                  >
                    <_Builtin.Heading tag="h3">
                      {"The MONTEREY"}
                    </_Builtin.Heading>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className="margin-bottom margin-medium"
                    tag="div"
                  >
                    <_Builtin.Paragraph>
                      {
                        "Situated just outside of Orange County, The Monterey apartment community in Corona boasts a prime location in close proximity to an array of dining establishments, thriving businesses and parks. This exceptional placement makes it the ultimate choice for an idyllic Corona living experience."
                      }
                    </_Builtin.Paragraph>
                  </_Builtin.Block>
                  <_Builtin.Block className="button-group" tag="div">
                    <ButtonPrimaryBlack
                      text="Find Your Home"
                      link={{
                        href: "/locations/",
                      }}
                    />
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block className="difference_component" tag="section">
            <_Builtin.Block className="padding-global mobile-none" tag="div">
              <_Builtin.Block className="container-large" tag="div">
                <_Builtin.Block className="mobile-padding-global" tag="div">
                  <_Builtin.Block className="communities_header" tag="div">
                    <_Builtin.Block
                      className="difference_heading-wrapper"
                      tag="div"
                    >
                      <_Builtin.Heading tag="h2">
                        {"THE SRG "}
                        <_Builtin.Span className="text-color-blue">
                          {"Difference"}
                        </_Builtin.Span>
                      </_Builtin.Heading>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className="decoration-line is-black"
                      tag="wrapper"
                    />
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block className="div-block-34" tag="div">
                  <_Builtin.Block className="mobile-padding-global" tag="div">
                    <_Builtin.Block className="max-width-medium" tag="div">
                      <_Builtin.Paragraph>
                        {
                          "At SRG Residential, we take utmost pride in being a reliable support system for our residents and employees, fostering strong and vibrant communities where everyone feels valued and cared for. We understand the importance of loving where you live and that's why we are committed to providing hassle-free living experiences."
                        }
                      </_Builtin.Paragraph>
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block className="stats-background" tag="div">
                    <_Builtin.Block tag="div">
                      <_Builtin.Block className="heading-style-h6" tag="div">
                        {"Locations"}
                      </_Builtin.Block>
                      <_Builtin.Block className="heading-style-h1" tag="div">
                        {"180+"}
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block tag="div">
                      <_Builtin.Block className="heading-style-h6" tag="div">
                        {"Founded"}
                      </_Builtin.Block>
                      <_Builtin.Block className="heading-style-h1" tag="div">
                        {"1993"}
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block className="matters" tag="section">
            <_Builtin.Block className="padding-global" tag="div">
              <_Builtin.Block className="container-large" tag="div">
                <_Builtin.Block className="padding-section-small" tag="div">
                  <_Builtin.Block className="frame-4" tag="div">
                    <_Builtin.Block tag="div">
                      <_Builtin.Block
                        className="margin-bottom margin-small"
                        tag="div"
                      >
                        <_Builtin.Heading className="heading-6" tag="h2">
                          {"What "}
                          <_Builtin.Span className="text-color-blue">
                            {"Matters"}
                          </_Builtin.Span>
                          <_Builtin.Span className="text-color-blue">
                            {""}
                          </_Builtin.Span>
                        </_Builtin.Heading>
                      </_Builtin.Block>
                      <_Builtin.Block
                        className="hide-mobile-landscape"
                        tag="div"
                      >
                        <_Builtin.Block className="button-group" tag="div">
                          <ButtonPrimaryWhite
                            text="About Sares-Regis"
                            link={{
                              href: "https://www.sares-regis.com/",
                              target: "_blank",
                            }}
                          />
                        </_Builtin.Block>
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block tag="div">
                      <MattersCardsGrid />
                      <_Builtin.Block
                        className="show-mobile-landscape"
                        tag="div"
                      >
                        <_Builtin.Block
                          className="margin-top margin-large"
                          tag="div"
                        >
                          <_Builtin.Block className="button-group" tag="div">
                            <ButtonPrimaryWhite text="About SRG Living" />
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <Gallery
            _1X1APropertyName="Cyrene at Fiddyment"
            _1X2BPropertyName="Roseville, CA"
            _2X1DPhoto="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dcb93993210214a7a068c2_2-Level%20at%20Sixteenth.jpeg"
            ePropertyName="1250 Lakeside"
            eCityState="Sunnyvale, CA"
            _1X1ACityState="Roseville, CA"
            cPhoto="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dcb939f00b356f854d27e4_7-royce.jpeg"
            gPhoto="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dcb939441387dfa8413294_5-Palomino.jpeg"
            ePhoto="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dcb939ffcaf05e124725df_6-1250%20Lakeside.jpeg"
            _1X1APhoto="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dcb939b4c30a8cdc0c5fd9_1-Cyrene%20at%20Fiddyment.jpeg"
            _2X1DPropertyName="Level at Sixteenth"
            cPropertyName="Promenade Rio Vista"
            cCitySt="San Diego, CA"
            fPhoto="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dcd3349614673cc8da5635_RoyceThe_04111815%202.jpg"
            fPropertyF="The Royce"
            fCitySt="Irvine, CA"
            gPropertyName="Palomino"
            gCitySt="Reno, NV"
            hPhoto="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65dcb939e62518487bdcf30c_8-The%20Heights%20at%20Park%20Lane.jpeg"
            hPropertyName="The Heights at Park Lane"
            hCitySt="Dallas, TX"
          />
          <_Builtin.Block className="testimonials" tag="section">
            <_Builtin.Block className="padding-global" tag="div">
              <_Builtin.Block className="container-large" tag="div">
                <_Builtin.Block className="padding-section-medium" tag="div">
                  <_Builtin.Block
                    className="margin-bottom margin-large"
                    tag="div"
                  >
                    <_Builtin.Block className="text-align-center" tag="div">
                      <_Builtin.Heading tag="h2">
                        {"From our "}
                        <_Builtin.Span className="text-color-blue">
                          {"Community"}
                        </_Builtin.Span>
                      </_Builtin.Heading>
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.SliderWrapper
                    className="testimonial7_component"
                    data-animation="slide"
                    data-duration="500"
                    data-infinite="1"
                    navSpacing={3}
                    navShadow={false}
                    autoplay={false}
                    delay={4000}
                    iconArrows={true}
                    animation="outin"
                    navNumbers={false}
                    easing="ease"
                    navRound={true}
                    hideArrows={false}
                    disableSwipe={false}
                    duration={500}
                    infinite={true}
                    autoMax={0}
                    navInvert={true}
                  >
                    <_Builtin.SliderMask className="testimonial7_mask">
                      <_Builtin.SliderSlide
                        className="testimonial7_slide"
                        tag="div"
                      >
                        <_Builtin.Block
                          className="testimonial7_content"
                          tag="div"
                        >
                          <_Builtin.Block
                            className="margin-bottom margin-small"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="heading-style-h6"
                              tag="div"
                            >
                              {
                                "Great staff, always friendly and courteous, very responsive whenever needed, special shout out to Kevin who went above and beyond helping with maintenance issues!!"
                              }
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="margin-bottom margin-tiny"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="text-size-large"
                              tag="div"
                            >
                              {"Patrick on Google"}
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="testimonial_address"
                            tag="div"
                          >
                            {"Aliso Creek"}
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.SliderSlide>
                      <_Builtin.SliderSlide
                        className="testimonial7_slide"
                        tag="div"
                      >
                        <_Builtin.Block
                          className="testimonial7_content"
                          tag="div"
                        >
                          <_Builtin.Block
                            className="margin-bottom margin-small"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="heading-style-h6"
                              tag="div"
                            >
                              {
                                "Can't thank the office ladies enough for being so accommodating and awesome to my family. We were new to the area and they made us feel so welcomed. Grounds are kept, management is great, and amazing location."
                              }
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="margin-bottom margin-tiny"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="text-size-large"
                              tag="div"
                            >
                              {"Alli on Google"}
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="testimonial_address"
                            tag="div"
                          >
                            {"Desert Parks Vista"}
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.SliderSlide>
                      <_Builtin.SliderSlide
                        className="testimonial7_slide"
                        tag="div"
                      >
                        <_Builtin.Block
                          className="testimonial7_content"
                          tag="div"
                        >
                          <_Builtin.Block
                            className="margin-bottom margin-small"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="heading-style-h6"
                              tag="div"
                            >
                              {
                                "I just moved in to Domain Weho. But have to say from the beginning Martin and his team made it the easiest. Everything was fast and efficient. They really are taking care of their residents and make sure they have the best experience living in this beautiful community. Highly recommend!"
                              }
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="margin-bottom margin-tiny"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="text-size-large"
                              tag="div"
                            >
                              {"Ksenia on Google"}
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="testimonial_address"
                            tag="div"
                          >
                            {"Domain WeHo"}
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.SliderSlide>
                      <_Builtin.SliderSlide
                        className="testimonial7_slide"
                        tag="div"
                      >
                        <_Builtin.Block
                          className="testimonial7_content"
                          tag="div"
                        >
                          <_Builtin.Block
                            className="margin-bottom margin-small"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="heading-style-h6"
                              tag="div"
                            >
                              {
                                "The management and maintenance staff at Eastlake deserve special commendation. They are responsive, friendly, and always go above and beyond to address any concerns promptly. It's evident that they prioritize the well-being and satisfaction of their residents. I highly recommend Eastlake to anyone in search of a modern, comfortable, and well-managed living space. It's not just an apartment; it's a community that prioritizes resident satisfaction and offers a lifestyle that exceeds expectations."
                              }
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="margin-bottom margin-tiny"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="text-size-large"
                              tag="div"
                            >
                              {"Chloe on Google"}
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="testimonial_address"
                            tag="div"
                          >
                            {"Eastlake 2851"}
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.SliderSlide>
                      <_Builtin.SliderSlide
                        className="testimonial7_slide"
                        tag="div"
                      >
                        <_Builtin.Block
                          className="testimonial7_content"
                          tag="div"
                        >
                          <_Builtin.Block
                            className="margin-bottom margin-small"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="heading-style-h6"
                              tag="div"
                            >
                              {
                                "Living in this building for just under two years was a delight! The apartments offer plenty of space and are aesthetically pleasing, but the highlight is the dedicated staff. Armando, the maintenance supervisor, deserves special mention. He was always prompt in addressing our concerns, tirelessly ensuring that every detail was attended to with care. His professionalism is unparalleled, and his genuine kindness adds a special touch to the community here."
                              }
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="margin-bottom margin-tiny"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="text-size-large"
                              tag="div"
                            >
                              {"Paula on Google"}
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="testimonial_address"
                            tag="div"
                          >
                            {"Etta"}
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.SliderSlide>
                      <_Builtin.SliderSlide
                        className="testimonial7_slide"
                        tag="div"
                      >
                        <_Builtin.Block
                          className="testimonial7_content"
                          tag="div"
                        >
                          <_Builtin.Block
                            className="margin-bottom margin-small"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="heading-style-h6"
                              tag="div"
                            >
                              {
                                "I've been living here for two years now and I can honestly say that I love this location. I've always been a huge fan of old Spanish architecture, and there is no shortage of that here; the city is absolutely gorgeous. The amenities at this building are great and the managers are awesome. Alondra always helps me with any of my questions or concerns. If you're considering a place in downtown Riverside, definitely set up a tour and ask for Alondra."
                              }
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="margin-bottom margin-tiny"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="text-size-large"
                              tag="div"
                            >
                              {"Smitty on Google"}
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="testimonial_address"
                            tag="div"
                          >
                            {"Imperial Hardware Lofts"}
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.SliderSlide>
                      <_Builtin.SliderSlide
                        className="testimonial7_slide"
                        tag="div"
                      >
                        <_Builtin.Block
                          className="testimonial7_content"
                          tag="div"
                        >
                          <_Builtin.Block
                            className="margin-bottom margin-small"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="heading-style-h6"
                              tag="div"
                            >
                              {
                                "From my initial building tour, move in...it has been a wonderful experience! Veronica, in the front office, is especially kind, responsive and helpful. I tell my friends that I feel like I just moved into a luxury hotel! The property is beautifully maintained and the amenities are very high end. I especially love the outdoor dog walking area so I can walk my dog at night. My maintenance request was addressed within an hour of submitting it. The location in Little Italy is amazing and I love the walkability. We are next to the train tracks and flight path but I find the building to be very quiet. Highly recommend living here :-)"
                              }
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="margin-bottom margin-tiny"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="text-size-large"
                              tag="div"
                            >
                              {"April on Google"}
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="testimonial_address"
                            tag="div"
                          >
                            {"Instrata Littley Italy"}
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.SliderSlide>
                      <_Builtin.SliderSlide
                        className="testimonial7_slide"
                        tag="div"
                      >
                        <_Builtin.Block
                          className="testimonial7_content"
                          tag="div"
                        >
                          <_Builtin.Block
                            className="margin-bottom margin-small"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="heading-style-h6"
                              tag="div"
                            >
                              {
                                "We lived here for 2 years and couldn't say anything but great reviews. Sean and the leasing office are always helpful and on top of concerns within your unit. This is one of the few places where I've lived where the maintenance staff come within 48 hours of an order. Likely shorter and almost immediate with â€œhigher priorityâ€ type of issues. George and Lin are both great. Ended up moving out due to work but highly suggest."
                              }
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="margin-bottom margin-tiny"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="text-size-large"
                              tag="div"
                            >
                              {"Ivan on Google"}
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="testimonial_address"
                            tag="div"
                          >
                            {"LINQ"}
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.SliderSlide>
                      <_Builtin.SliderSlide
                        className="testimonial7_slide"
                        tag="div"
                      >
                        <_Builtin.Block
                          className="testimonial7_content"
                          tag="div"
                        >
                          <_Builtin.Block
                            className="margin-bottom margin-small"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="heading-style-h6"
                              tag="div"
                            >
                              {
                                "Excellent community, I live here and they have good organization, nice social areas, apartments in perfect condition and the best of all is the administration's attention. I recommend them 100%."
                              }
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="margin-bottom margin-tiny"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="text-size-large"
                              tag="div"
                            >
                              {"Jesus On Goole"}
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="testimonial_address"
                            tag="div"
                          >
                            {"Miro at the Parc"}
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.SliderSlide>
                      <_Builtin.SliderSlide
                        className="testimonial7_slide"
                        tag="div"
                      >
                        <_Builtin.Block
                          className="testimonial7_content"
                          tag="div"
                        >
                          <_Builtin.Block
                            className="margin-bottom margin-small"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="heading-style-h6"
                              tag="div"
                            >
                              {
                                "From our first tour to the day we signed our lease, the entire staff at Palomino Apartments when above beyond for my family! They made the process easy to navigate and were kind enough to work with us on our move-in date as we're moving cross-country with our newborn daughter. Thank you to Sydnee, Stephanie, and to everyone else who were there to help us. Looking forward to moving into our new home!"
                              }
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="margin-bottom margin-tiny"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="text-size-large"
                              tag="div"
                            >
                              {"Mike on Goolge"}
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="testimonial_address"
                            tag="div"
                          >
                            {"Palomino"}
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.SliderSlide>
                      <_Builtin.SliderSlide
                        className="testimonial7_slide"
                        tag="div"
                      >
                        <_Builtin.Block
                          className="testimonial7_content"
                          tag="div"
                        >
                          <_Builtin.Block
                            className="margin-bottom margin-small"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="heading-style-h6"
                              tag="div"
                            >
                              {
                                "These apartments are beautiful, I truly enjoy living here. Krista in the front office is always cheerful, and willing to help, never makes me feel like a bother when I have 10,000 questions. The amenities are always well kept, and never too crowded. I could see myself living her for several more years. It's also right down the street from my work!"
                              }
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="margin-bottom margin-tiny"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="text-size-large"
                              tag="div"
                            >
                              {"Zaria on Google"}
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="testimonial_address"
                            tag="div"
                          >
                            {"Terracina"}
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.SliderSlide>
                      <_Builtin.SliderSlide
                        className="testimonial7_slide"
                        tag="div"
                      >
                        <_Builtin.Block
                          className="testimonial7_content"
                          tag="div"
                        >
                          <_Builtin.Block
                            className="margin-bottom margin-small"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="heading-style-h6"
                              tag="div"
                            >
                              {
                                "Extremely well maintained property, fabulous location, and the staff is amazing. Felicia is so helpful. We love living here!"
                              }
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="margin-bottom margin-tiny"
                            tag="div"
                          >
                            <_Builtin.Block
                              className="text-size-large"
                              tag="div"
                            >
                              {"Loren on Google"}
                            </_Builtin.Block>
                          </_Builtin.Block>
                          <_Builtin.Block
                            className="testimonial_address"
                            tag="div"
                          >
                            {"Trend Design District"}
                          </_Builtin.Block>
                        </_Builtin.Block>
                      </_Builtin.SliderSlide>
                    </_Builtin.SliderMask>
                    <_Builtin.SliderArrow
                      className="testimonial7_arrow is-left"
                      dir="left"
                    >
                      <_Builtin.Block
                        className="arrow-icon-container"
                        tag="div"
                      >
                        <_Builtin.HtmlEmbed
                          className="icon-embed-xsmall"
                          value="%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20aria-hidden%3D%22true%22%20role%3D%22img%22%20class%3D%22iconify%20iconify--heroicons%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20preserveaspectratio%3D%22xMidYMid%20meet%22%20viewbox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22none%22%20stroke%3D%22currentColor%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20d%3D%22M6.75%2015.75L3%2012m0%200l3.75-3.75M3%2012h18%22%2F%3E%3C%2Fsvg%3E"
                        />
                      </_Builtin.Block>
                    </_Builtin.SliderArrow>
                    <_Builtin.SliderArrow
                      className="testimonial7_arrow is-right"
                      dir="right"
                    >
                      <_Builtin.Block
                        className="arrow-icon-container"
                        tag="div"
                      >
                        <_Builtin.HtmlEmbed
                          className="icon-embed-xsmall"
                          value="%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20aria-hidden%3D%22true%22%20role%3D%22img%22%20class%3D%22iconify%20iconify--heroicons%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20preserveaspectratio%3D%22xMidYMid%20meet%22%20viewbox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22none%22%20stroke%3D%22currentColor%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20d%3D%22M17.25%208.25L21%2012m0%200l-3.75%203.75M21%2012H3%22%2F%3E%3C%2Fsvg%3E"
                        />
                      </_Builtin.Block>
                    </_Builtin.SliderArrow>
                    <_Builtin.SliderNav className="testimonial7_slide-nav" />
                  </_Builtin.SliderWrapper>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block className="contact" tag="section">
            <_Builtin.Grid className="contact_component" tag="div">
              <_Builtin.Block className="contact_image-wrapper" tag="div">
                <_Builtin.Image
                  className="contact_image"
                  loading="lazy"
                  width="auto"
                  height="auto"
                  alt=""
                  src="https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/65d92424f8bed11d14d5ed0f_srg-familyimg.jpeg"
                />
              </_Builtin.Block>
              <_Builtin.Block className="contact_content" tag="div">
                <_Builtin.Block className="max-width-medium" tag="div">
                  <_Builtin.Block
                    className="margin-bottom margin-medium"
                    tag="div"
                  >
                    <_Builtin.Block
                      className="margin-bottom margin-small"
                      tag="div"
                    >
                      <_Builtin.Heading tag="h2">
                        {"Contact us"}
                      </_Builtin.Heading>
                    </_Builtin.Block>
                    <_Builtin.Paragraph className="text-size-small">
                      {
                        "You can count on us to be readily available, address inquiries and make sure your home remains a source of comfort and happiness, as you settle in and create lasting memories."
                      }
                      <br />
                      <br />
                      {
                        "If you are a current resident, additional help is available by contacting your community manager through your "
                      }
                      <_Builtin.Link
                        button={false}
                        block=""
                        options={{
                          href: "#",
                        }}
                      >
                        {"resident portal"}
                      </_Builtin.Link>
                      {". *Please no solicitations."}
                    </_Builtin.Paragraph>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className="margin-bottom margin-large"
                    tag="div"
                  >
                    {formSlot ?? (
                      <ContactFormHomePage
                        formRuntimeProps={{}}
                        communitySelectRuntimeProp={{}}
                      />
                    )}
                  </_Builtin.Block>
                  <_Builtin.Block tag="div">
                    <_Builtin.Block
                      className="margin-bottom margin-medium"
                      tag="div"
                    >
                      <_Builtin.Heading tag="h2">
                        {"Find a Home"}
                      </_Builtin.Heading>
                    </_Builtin.Block>
                    <_Builtin.Block className="div-block-37" tag="div">
                      <_Builtin.Link
                        className="button is-icon"
                        button={false}
                        block="inline"
                        options={{
                          href: "/locations/",
                        }}
                      >
                        <_Builtin.Block tag="div">{"Locations"}</_Builtin.Block>
                        <_Builtin.HtmlEmbed
                          className="icon-embed-xsmall"
                          value="%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20aria-hidden%3D%22true%22%20role%3D%22img%22%20class%3D%22iconify%20iconify--heroicons%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20preserveaspectratio%3D%22xMidYMid%20meet%22%20viewbox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22none%22%20stroke%3D%22currentColor%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20d%3D%22M17.25%208.25L21%2012m0%200l-3.75%203.75M21%2012H3%22%2F%3E%3C%2Fsvg%3E"
                        />
                      </_Builtin.Link>
                      <_Builtin.Link
                        className="button is-icon"
                        button={false}
                        block="inline"
                        options={{
                          href: "#",
                        }}
                      >
                        <_Builtin.Block tag="div">{"Residents"}</_Builtin.Block>
                        <_Builtin.HtmlEmbed
                          className="icon-embed-xsmall"
                          value="%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20aria-hidden%3D%22true%22%20role%3D%22img%22%20class%3D%22iconify%20iconify--heroicons%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20preserveaspectratio%3D%22xMidYMid%20meet%22%20viewbox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22none%22%20stroke%3D%22currentColor%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20d%3D%22M17.25%208.25L21%2012m0%200l-3.75%203.75M21%2012H3%22%2F%3E%3C%2Fsvg%3E"
                        />
                      </_Builtin.Link>
                      <_Builtin.Link
                        className="button is-icon"
                        button={false}
                        block="inline"
                        options={{
                          href: "/applicants/",
                        }}
                      >
                        <_Builtin.Block tag="div">{"Careers"}</_Builtin.Block>
                        <_Builtin.HtmlEmbed
                          className="icon-embed-xsmall"
                          value="%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20aria-hidden%3D%22true%22%20role%3D%22img%22%20class%3D%22iconify%20iconify--heroicons%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20preserveaspectratio%3D%22xMidYMid%20meet%22%20viewbox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22none%22%20stroke%3D%22currentColor%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20d%3D%22M17.25%208.25L21%2012m0%200l-3.75%203.75M21%2012H3%22%2F%3E%3C%2Fsvg%3E"
                        />
                      </_Builtin.Link>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Grid>
          </_Builtin.Block>
        </_Builtin.Block>
        <Footer />
      </_Builtin.Block>
    </_Component>
  );
}
